import { AbstractControl, ValidationErrors } from '@angular/forms';
import dayjs from 'dayjs';
import { germanDayJsDate } from '@ps-gui/shared-utils';

export enum ERROR_KEYS {
  INCORRECT_DATE_FORMAT = 'incorrectDateFormat',
  FROM_DATE_AFTER_TO_DATE = 'fromDateAfterToDate',
}

export const germanDateValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) return null;

  const parsedDate = dayjs(control.value, 'DD.MM.YYYY', true);
  return parsedDate.isValid()
    ? null
    : {
        [ERROR_KEYS.INCORRECT_DATE_FORMAT]: true,
      };
};

//TODO generalize
export const toDateAfterFromDateValidator = (control: AbstractControl) => {
  const fromControl = control.get('von');
  const toControl = control.get('bis');

  const fromDate = fromControl?.value;
  const toDate = toControl?.value;

  if (!fromDate || !toDate) return null;

  const isFromDateAfterToDate = germanDayJsDate(fromDate).isAfter(germanDayJsDate(toDate));

  if (!isFromDateAfterToDate) return null;

  return {
    [ERROR_KEYS.FROM_DATE_AFTER_TO_DATE]: true,
  };
};

export const extendErrors = (
  errors: ValidationErrors | null,
  errorName: string,
  isError: boolean,
): ValidationErrors | null => {
  if (isError) {
    return { ...(errors ?? {}), [errorName]: true };
  } else {
    if (errors) {
      delete errors[errorName];
      if (Object.keys(errors).length === 0) {
        return null;
      }
    }
    return errors;
  }
};
